<template>
  <div class="div-quill-editor defaultsize">
    <div class="quill-editor-example">
    <!-- quill-editor -->
    <quill-editor ref="myTextEditor"
                    v-model="content"
                    :options="editorOption"
                    >
    </quill-editor>
    <div class="quill-code">
        <code class="hljs"></code>
    </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";
  import hljs from 'highlight.js';
  import { quillEditor } from 'vue-quill-editor';
  import 'quill/dist/quill.core.css';
  import 'quill/dist/quill.snow.css';
  import 'quill/dist/quill.bubble.css';
  export default {
    data() {
      return {
        name: '01-example',
        components: {
            quillEditor
        },      
        editorOption: {
          placeholder:"コメントを入力",
          modules: {
            toolbar: [
              ['bold'],
              [{ 'color': [] }],
              [{ 'align': [] }],
              ['link'],
              []
            ],
           }
        }
      }
    },
    computed: {
      ...mapGetters("situation1023", [
			"getArticleComment"
			]),
      editor() {
        return this.$refs.myTextEditor.quill
      },
      content: {
          get () {
                  return this.getArticleComment;
          },
          set (newvalue) {
                  this.$store.commit('situation1023/setArticleComment', newvalue)
          }
      },
      contentCode() {
        return hljs.highlightAuto(this.content).value
      }
    },
  }
</script>

<style scoped>
.quill-code {
    border: none;
    height: auto;    
    display: none;
}

.code {
    width: 100%;
    margin: 0;
    padding: 1rem;
    border: 1px solid #ccc;
    border-top: none;
    border-radius: 0;
    height: 20rem;
    overflow-y: auto;
    resize: vertical;
    margin-bottom: 50px;
    text-align: center;
}

.div-quill-editor {
    margin-bottom: 50px;
}

.div-quill-editor {
  margin: 0px auto;
}

.defaultsize {
  margin-bottom: 30px;
}

</style>